export enum AuthActionTypes {
  CHANGE_STUDENT_NUM = '@@user/CHANGE_STUDENT_NUM',
  CHANGE_EMAIL = '@@user/CHANGE_EMAIL',
  CHANGE_PASSWORD = '@@user/CHANGE_PASSWORD',
  CLICK_MARKETING = '@@user/CLICK_MARKETING',
  CLICK_TERMS = '@@user/CLICK_TERMS',
  COGNITO_LOGIN_REQUEST = '@@auth/COGNITO_LOGIN_REQUEST',
  COGNITO_LOGIN_SUCCESS = '@@auth/COGNITO_LOGIN_SUCCESS',
  TEST_LOGIN_SUCCESS = '@@auth/TEST_LOGIN_SUCCESS',
  COGNITO_LOGIN_FAILURE = '@@auth/COGNITO_LOGIN_FAILURE',
  COGNITO_REAUTH_REQUEST = '@@auth/COGNITO_REAUTH_REQUEST',
  COGNITO_REAUTH_SUCCESS = '@@auth/COGNITO_REAUTH_SUCCESS',
  COGNITO_REAUTH_FAILURE = '@@auth/COGNITO_REAUTH_FAILURE',
  LOGOUT_REQUEST = '@@auth/LOGOUT_REQUEST',
  COGNITO_LOGOUT_SUCCESS = '@@auth/COGNITO_LOGOUT_SUCCESS',
  COGNITO_LOGOUT_FAILURE = '@@auth/COGNITO_LOGOUT_FAILURE',
  RESET_PASSWORD_REQUEST = '@@auth/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS = '@@auth/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE = '@@auth/RESET_PASSWORD_FAILURE',
  GET_CURRENT_USER_REQUEST = '@@auth/GET_CURRENT_USER_REQUEST',
  GET_CURRENT_USER_SUCCESS = '@@auth/GET_CURRENT_USER_SUCCESS',
  GET_CURRENT_USER_FAILURE = '@@auth/GET_CURRENT_USER_FAILURE',
  CHANGE_PASSWORD_REQUEST = '@@auth/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS = '@@auth/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE = '@@auth/CHANGE_PASSWORD_FAILURE',
}

export interface AuthState {
  readonly student_number: string;
  readonly email: string;
  readonly terms: boolean;
  readonly marketing: boolean;
  readonly validation_errors?: ReadonlyArray<{
    field: string;
    message: string;
  }>;
  readonly server_errors?: ReadonlyArray<string>;
  readonly isAuthenticating: boolean;
  readonly isLoggedIn: boolean;
  readonly isCodeSent: boolean;
  readonly userName?: string;
  readonly password: string;
  readonly resetPasswordRequestSent?: boolean;
  readonly resetPasswordRequestError?: string;
  readonly resetPasswordWithCodeSent?: boolean;
  readonly resetPasswordRequestWithCodeError?: string;
  readonly changePasswordRequestSent?: boolean;
  readonly changePasswordResponseError?: string;
  readonly studentMfaStatus?: boolean;
}
